// src/components/Navbar.js
import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { db, auth } from "../firebase";
import { collection, doc, getDoc, getDocs, serverTimestamp, setDoc, updateDoc } from "firebase/firestore";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import SubCard from "../components/SubCard";
import { Button, Container, Offcanvas } from "react-bootstrap";
import { generateUsername } from "../utils/usernameGenerator";
import { signInWithPopup } from "firebase/auth";
import {provider } from "../firebase";

export default function Navbar() {
  const navigate = useNavigate();
  
  const [showDrawer, setShowDrawer] = useState(false);
  const [profile, setProfile] = useState(null);
  const [userName, setUserName] = useState("");
  const [showUsernameModal, setShowUsernameModal] = useState(false);
  const [userPhotoURL, setUserPhotoURL] = useState("");
  

  const openDrawer = () => setShowDrawer(true);
  const closeDrawer = () => setShowDrawer(false);
  // const auth = getAuth();
  const [user, setUser] = useState(null);

  const fileInputRef = useRef(null);

  
  useEffect(() => {
  const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
    if (!firebaseUser) {
      navigate("/");
      return;
    }

    setUser(firebaseUser);

    const userDoc = await getDoc(doc(db, "subusers", firebaseUser.uid)); // ✅ fix collection

    if (!userDoc.exists()) return;

    const data = userDoc.data();

    setUserName(data.username || "");
    setUserPhotoURL(data.photoURL || firebaseUser.photoURL);

    if (data.changedUsername === false) {
      const suggestion = generateUsername(firebaseUser.displayName);
      setUserName(suggestion);
      setShowUsernameModal(true);
    }

    setProfile({
      name: data.username || firebaseUser.displayName,
      photo: data.photoURL || firebaseUser.photoURL,
      // groupsJoined: data?.stats?.groupsJoined || 0,
      // totalVotes: data?.stats?.totalVotesReceived || 0,
      // officialMessages: data?.stats?.officialMessages || 0,
      // groupsStarted: data?.stats?.groupsStarted || 0,
      // groups: data?.groups || []
    });
  });

  return () => unsubscribe();
}, [navigate]);

  const handleAvatarClick = () => {
    fileInputRef.current.click();
  };

  const handleSignOut = async () => {
    await signOut(auth);
    navigate("/");
  };

  const handleSignIn = async () => {
    const result = await signInWithPopup(auth, provider);
        const user = result.user;
    
        const userRef = doc(db, "subusers", user.uid);
        const userSnap = await getDoc(userRef);
    
        if (!userSnap.exists()) {
          let newUsername = generateUsername();
          
          await setDoc(userRef, {
            username: newUsername,
            email: user.email,
            createdAt: serverTimestamp(),
            savedSubs: [],
            userId: user.uid,
          });
        } else {
          await updateDoc(userRef, {
            email: user.email
          });
        }
    
        navigate("/");
  }


  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 1000,
        backdropFilter: "blur(12px)",
        background: "rgba(255,255,255,0.7)",
        borderBottom: "1px solid #eee"
      }}
    >
      <div
        style={{
          maxWidth: 700,
          margin: "0 auto",
          padding: "12px 16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
         <Link style={{
              fontWeight: 700,
              color: "#0d0101"
            }} className="navbar-brand" to="/">
          PlaySubs
        </Link>

         {/* Hamburger */}
          <Button
            variant="light"
            onClick={openDrawer}
            className="rounded-circle"
            style={{
              width: "40px",
              height: "40px",
              fontSize: "18px",
              padding: 0
            }}
          >
            ☰
          </Button>
      </div>
      <div className="container">
       

        <div>

         
        </div>
      </div>
      <Offcanvas
        show={showDrawer}
        onHide={closeDrawer}
        placement="end"
      >

        <Offcanvas.Header closeButton>
          <Offcanvas.Title
            style={{
              fontWeight: 700,
              color: "#0d0101",
              fontSize: "15px"

            }}
          >
            PlaySubs
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>

          {user && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                marginBottom: "25px"
              }}
            >
              <img
                onClick={handleAvatarClick}
                src={userPhotoURL || "https://via.placeholder.com/40"}
                alt="avatar"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  objectFit: "cover"
                }}
              />

              <div>
                <div style={{ fontWeight: 600 }}>
                  @{userName ? userName.replace(/\s+/g, "") : "user"}
                </div>

                {/* <div style={{ fontSize: "12px", color: "#777" }}>
                  {user.email}
                </div> */}
              </div>
            </div>
          )}


          {user ? (
            <Button
              onClick={handleSignOut}
              className="w-100 mb-3 rounded-pill"
              style={{
              background: "linear-gradient(135deg,#000000,#000000)",
              border: "none"
            }}
            >
              Sign out
            </Button>
          ) : (
            <Button
              onClick={handleSignIn}
              className="w-100 mb-3 rounded-pill"
              style={{
              background: "linear-gradient(135deg,#000000,#000000)",
              border: "none"
            }}
            >
              Sign in
            </Button>
          )}

        </Offcanvas.Body>

      </Offcanvas>
    </div>
  );
}